export default {
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR',
    },
  },
  de: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
    },
  },
};
